import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormComponentBase } from '../../../core/component/forms/form-component.base';
import { standardCommand } from '../../../core/model/command';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { InvoiceRowGroup } from '../../model/invoice-row-group';
import { InvoiceRowGroupService } from '../../service/data/invoice-row-group.service';
import { Features, ModuleNames } from '../../../common/model/account-definition';
import { UserAccountService } from '../../../common/service/user-account.service';

@Component({
    selector: 'app-invoice-row-group-form',
    templateUrl: './invoice-row-group-form.component.html',
    styleUrls: ['./invoice-row-group-form.component.scss'],
    providers: [DeleteFormCommandHandler, FormCommandHandlerResolver, { provide: DataService, useExisting: InvoiceRowGroupService }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoiceRowGroupFormComponent extends FormComponentBase<InvoiceRowGroup> {
  canManageInvoiceRowGroups = false;

  constructor(
    private _fb: FormBuilder,
    private _fc: FormControlExFactory,
    activatedRoute: ActivatedRoute,
    commandDispatcher: CommandDispatcher,
    handlerResolver: FormCommandHandlerResolver,
    service: InvoiceRowGroupService,
    accountService: UserAccountService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, service, messageService, navigation, commandDispatcher, handlerResolver);
    this.addDeleteMenu = false;
    this.AddSubscription(
      accountService.current.subscribe(account => {
        this.canManageInvoiceRowGroups = account.hasAccess(ModuleNames.Invoicing, Features.InvoiceRowGroup);
        if (this.canManageInvoiceRowGroups) {
          this.addMenuItemDefinition('CREATE_BTN', standardCommand.create);
          this.addMenuItemDefinition('DELETE_BTN', standardCommand.delete);
        }
      })
    );
  }

  protected createModel(): InvoiceRowGroup {
    return new InvoiceRowGroup();
  }

  protected getFormGroup(): FormGroup {
    return this._fb.group({
      id: this._fc.createHidden(this.dataContext.id),
      caption: this._fc.createMandatory('INVOICE_ROW_GROUP.CAPTION', this.dataContext.caption),
    });
  }

  protected init(data: InvoiceRowGroup): void {
    super.init(data);
    if (!this.canManageInvoiceRowGroups) {
      this.form.disable({ emitEvent: false });
    }
  }
}
